import { Colors } from 'assets/colors';
import styled from 'styled-components';

export const StyledWrapper = styled.div`
  width: 100%;

  .box {
    background: color-mix(in srgb, ${Colors.primary1} 9%, white);
    border: 1px solid color-mix(in srgb, ${Colors.primary1} 22%, white);
    border-radius: 10px;
    padding: 16px 20px;
  }

  .box-header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 12px;
    flex-wrap: wrap;
  }

  .box-title {
    display: flex;
    align-items: center;
    gap: 8px;
    font-weight: 700;
    font-size: 16px;
    line-height: 22px;
    color: ${Colors.textPrimary1};
  }

  .box-desc {
    display: flex;
    align-items: center;
    gap: 6px;
    margin-top: 10px;
    font-weight: 500;
    font-size: 13px;
    line-height: 18px;
    color: #717679;

    .info-icon {
      color: ${Colors.primary1};
      flex-shrink: 0;
    }
  }

  @media (max-width: 575.98px) {
    .box {
      padding: 14px 16px;
    }
  }
`;

export const StyledModalContent = styled.div`
  .section-title {
    font-weight: 700;
    font-size: 14px;
    line-height: 20px;
    color: ${Colors.textPrimary1};
    margin-bottom: 4px;
  }

  .section-subtitle {
    font-weight: 500;
    font-size: 13px;
    line-height: 18px;
    color: #717679;
    margin-bottom: 12px;
  }

  .check-list {
    display: flex;
    flex-direction: column;
    gap: 10px;
    margin-bottom: 8px;
  }

  .check-row {
    display: flex;
    align-items: flex-start;
    gap: 10px;
    font-weight: 500;
    font-size: 14px;
    line-height: 20px;
    color: ${Colors.textPrimary1};

    .status-icon {
      font-size: 18px;
      margin-top: 1px;
      flex-shrink: 0;

      &--pass {
        color: ${Colors.success};
      }

      &--fail {
        color: #d53c2e;
      }
    }

    .check-label {
      display: flex;
      flex-direction: column;
    }

    .check-hint {
      font-weight: 500;
      font-size: 12px;
      line-height: 16px;
      color: #a01c11;
      margin-top: 2px;
    }
  }

  .current-values {
    background: #f5f8f7;
    border-radius: 8px;
    padding: 12px 14px;
    display: flex;
    flex-direction: column;
    gap: 10px;
    margin-bottom: 4px;
  }

  .value-row {
    display: flex;
    flex-direction: column;
    gap: 2px;

    .value-label {
      font-weight: 500;
      font-size: 12px;
      line-height: 16px;
      color: #717679;
    }

    .value-data {
      font-weight: 600;
      font-size: 14px;
      line-height: 18px;
      color: ${Colors.textPrimary1};
      word-break: break-word;
    }
  }

  .check-empty {
    font-weight: 500;
    font-size: 13px;
    line-height: 18px;
    color: #717679;
  }

  .manual-list {
    display: flex;
    flex-direction: column;
    gap: 10px;

    .ant-checkbox-wrapper {
      margin-left: 0;
      align-items: flex-start;
      font-weight: 500;
      font-size: 14px;
      line-height: 20px;
      color: ${Colors.textPrimary1};
    }
  }

  .support-note {
    background: #faf3e6;
    border-radius: 8px;
    padding: 10px 14px;
    font-weight: 500;
    font-size: 13px;
    line-height: 18px;
    color: #8a6100;
  }
`;
